import React, { useEffect, useContext, useRef, useState } from 'react'
import { StateController } from './../../App'
import useWidth from '../../hooks/useWidth'
import VerticalCenter from '../../layouts/VerticalCenter/VerticalCenter'
import Icon from '../atoms/Icon'

function VideoModal({
  show,
  setShowModal,
}) {
  const { width } = useWidth();
  const { setMdalOpen } = useContext(StateController)

  useEffect(() => {
    setMdalOpen(show);
    
    if (show) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [show]);

  const close = () => {
    setShowModal(false)
  }

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [progress, setProgress] = useState(0);
  const [overlayIcon, setOverlayIcon] = useState(null); // "play" o "pause"

  const togglePlay = () => {
    const video = videoRef.current;
    if (video.paused) {
      video.play();
      setIsPlaying(true);
      showOverlay('play');
    } else {
      video.pause();
      setIsPlaying(false);
      showOverlay('pause');
    }
  };

  const showOverlay = (type) => {
    setOverlayIcon(type);
    setTimeout(() => setOverlayIcon(null), 500); // Oculta ícono tras 500ms
  };

  const handleTimeUpdate = () => {
    const video = videoRef.current;
    const percent = (video.currentTime / video.duration) * 100;
    setProgress(percent);
  };

  const handleProgressClick = (e) => {
    const video = videoRef.current;
    const rect = e.target.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;
    video.currentTime = percent * video.duration;
  };

  const handleFullscreen = () => {
    const video = videoRef.current;
    if (video.requestFullscreen) {
      video.requestFullscreen();
    }
  };

  return (
    <div className={`mc-video-modal ${show && 'mc-video-modal__opened'} slow_ani`}>
      <div className="mc-video-modal__overlay slow_ani" onClick={close}></div>
      <div className="mc-video-modal__center">
        <VerticalCenter>
          <div className="mc-video-modal__close" onClick={close}>
            <Icon name="close" />
          </div>
          <div className={`mc-video-modal__center--window slow_ani`} onClick={togglePlay}>
            <video
              ref={videoRef}
              onTimeUpdate={handleTimeUpdate}
              src={width > 992 ? "/assets/videos/video.mp4" : "/assets/videos/video_mb.mp4"}
              className="video"
              poster={width > 992 ? "/assets/images/portada_desktop.png" : "/assets/images/portada_mobile.png"}
            />

            {overlayIcon &&
              <div className="video-overlay-icon animate-pop">
                {overlayIcon === 'play' ? <img src="/assets/images/play.png" /> :  <img src="/assets/images/pause.svg" />}
              </div>
            }
            
            <div className="progress-bar" onClick={handleProgressClick}>
              <div className="progress" style={{ width: `${progress}%` }}></div>
            </div>
            <div className="controls" onClick={(e) => e.stopPropagation()}>
              <button onClick={togglePlay} className="btn">
                {isPlaying 
                  ?  <Icon name='stop_video' /> :  <Icon name='play_video' />}
              </button>
              <button onClick={handleFullscreen} className="btn"><Icon name='size_video' /></button>
            </div>
          </div>
          <p onClick={close}>Elegir mi meta<Icon name='flecha_video' /></p>
        </VerticalCenter>
      </div>
    </div>
  )
}

export default VideoModal